<object-filters-group *ngFor="let group of groups" [group]="group" [formGroup]="formGroup"></object-filters-group>
